import { Group, Modal, Space, Stack, Text } from '@mantine/core';
import { FC, useContext, useEffect, useState } from 'react';
import { useDisclosure } from '@mantine/hooks';
import { i18n } from '@lingui/core';
import { useSearchParams } from 'react-router-dom';
import { MessageContext } from '../../Service/Context/MessageContextV2';
import { EmailBoxContext } from '../../Service/Context/EmailBoxContext';
import { ThemeTitle } from '../../Atoms/ThemeText';
import { MessageType } from '../../Types/MessageT';
import { MailS } from '../../Service/MailS';
import MessageModal from './MessageModal';
import { LoadTemplateModal } from './MessageModals';
import EmailActions from './EmailActions';
import EmailFolderActions from './EmailFolderActions';

const EmailsListHeader: FC<{ phoneVersion: boolean }> = ({ phoneVersion }) => {
  const [searchParams] = useSearchParams();
  const { selectedMessage, openedFolder, isBookitupScope } = useContext(EmailBoxContext);
  const { action, setAction } = useContext(MessageContext);
  const [opened, { open, close }] = useDisclosure(false);
  const preselectedTemplate = searchParams.get('message_template');
  const [showMessageTemplateModal, setMessageTemplateModal] = useState(preselectedTemplate !== null);

  useEffect(() => {
    if (!action && opened) {
      close();
    }
    if (phoneVersion && action && !opened) {
      open();
    }
  }, [action]);

  return (
    <>
      {!(selectedMessage && phoneVersion) && (
        <Group position="apart">
          <Stack spacing={0}>
            {openedFolder && (
              <>
                <ThemeTitle order={4}>{MailS.getFolderLabel(openedFolder.name)}</ThemeTitle>
                {!phoneVersion && !isBookitupScope && (
                  <Text color="dimmed" size="xs">
                    {MailS.getFolderCountDescription(openedFolder)}
                  </Text>
                )}
                {phoneVersion && <Space h="sm" />}
              </>
            )}
          </Stack>
          <Group p={phoneVersion ? 0 : 5} px={phoneVersion ? 0 : 10} position="apart">
            <EmailFolderActions phoneVersion={phoneVersion} loadTemplate={() => setMessageTemplateModal(true)} />
            {isBookitupScope && <EmailActions phoneVersion={phoneVersion} />}
          </Group>
        </Group>
      )}

      <Modal
        closeOnClickOutside={false}
        transition="slide-down"
        opened={showMessageTemplateModal}
        onClose={() => setMessageTemplateModal(false)}
        title={
          <Text size="xl" weight="bolder">
            Vorlage auswählen
          </Text>
        }
        zIndex={201}
      >
        <LoadTemplateModal
          onClose={() => setMessageTemplateModal(false)}
          defaultValue={preselectedTemplate as MessageType}
        />
      </Modal>
      {phoneVersion && (
        <Modal
          closeOnClickOutside={false}
          size={550}
          transition="slide-down"
          opened={opened}
          onClose={() => {
            close();
            setAction(null);
          }}
          title={
            <Text size="lg" weight="bolder">
              {i18n._(`messaging.action.${action}`)}
            </Text>
          }
        >
          <MessageModal loadTemplate={() => setMessageTemplateModal(true)} />
        </Modal>
      )}
      {!phoneVersion && <Space my="xs" />}
    </>
  );
};

export default EmailsListHeader;
